import { createAppAsyncThunk } from "core/src/store/store.types";
import { Location } from "core/src/ports/navigation-service.interface";

export const storeLatestLocation = createAppAsyncThunk<Location | null, void>(
	"navigation/storeLatestLocation",
	(_, { extra }) => {
		return extra.navigationService.getLocation();
	}
);
